import React from 'react';
import { CreateSimpleFormPage } from './CreateSimpleFormPage';
import { Form as FormType } from '../types';

interface CreateFormPageProps {
    form: FormType;
    appId: string;
}

export const CreateFormPage: React.FC<CreateFormPageProps> = (props) => {
    return <CreateSimpleFormPage {...props} />;
};
